import React from 'react';
import './contact.css';
import { Navbar, Header, Footer } from '../../components';

const Contact = () => {
  return (
    <div>
      <Navbar />
      <main id="page-content" tabIndex="-1">
        <Header />
        <section className="contact-hero">
          <div className="contact-intro">
            <h2>Get in touch — Building Systems for the Future</h2>
            <p className="muted">For project inquiries, collaborations, or speaking engagements — let's design impact at scale.</p>
          </div>
          <div className="contact-form-wrapper">
            <iframe 
              src="https://docs.google.com/forms/d/e/1FAIpQLSeLr9OkXMzwNvQ4puRrfi87ouE_EJl3ei7rb1Jqt1z_mKXhnA/viewform?embedded=true" 
              width="100%" 
              height="800" 
              frameBorder="0" 
              marginHeight="0" 
              marginWidth="0"
              title="Contact Form"
            >
              Loading…
            </iframe>
          </div>
        </section>

          <div className="text-center text-white mt-4">
            <h5>Follow Me</h5>
            <a href="https://www.linkedin.com/in/goodness-ononogbu/" target="_blank" rel="noopener noreferrer" className="text-decoration-none me-3" aria-label="LinkedIn profile">
              <i className="bi bi-linkedin fs-3" aria-hidden="true"></i>
            </a>
            <a href="mailto:ononogbugoodness@gmail.com" className="text-decoration-none me-3" aria-label="Send email">
              <i className="bi bi-envelope fs-3" aria-hidden="true"></i>
            </a>
          </div>
          </main>
      <Footer />
    </div>
  )
}

export default Contact
